import { useRequest } from 'features/request/useRequest';
import { graphql } from 'gql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

interface IUseCopyActSkzsPlanProps {
    onSuccess: () => void;
}

const uerActKC2CopyPlanVolumeSKzSUERGql = graphql(`
    mutation uerActKC2CopyPlanVolumeSKzSUER($actKC2Id: Long!, $workOrderPriceId: Long!) {
        uerActKC2CopyPlanVolumeSKzSUER(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
const uerActKC2CopyPlanVolumeSKzSGql = graphql(`
    mutation uerActKC2CopyPlanVolumeSKzS($actKC2Id: Long!) {
        uerActKC2CopyPlanVolumeSKzS(actKC2Id: $actKC2Id) {
            data {
                id
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const useCopyActSkzsPlan = (props: IUseCopyActSkzsPlanProps) => {
    const { onSuccess } = props;

    const dispatch = useDispatch();

    const [, , , copyActPriceSkzsPlanValueRequest] = useRequest({
        requestId: 'copyActPriceSkzsPlanValue',
        query: uerActKC2CopyPlanVolumeSKzSUERGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const [, , , copyActAllSkzsValuesRequest] = useRequest({
        requestId: 'copyActAllSkzsValues',
        query: uerActKC2CopyPlanVolumeSKzSGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const handleCopyPricePlanValue = useCallback(
        (actId: number, workOrderPriceId: number) => {
            dispatch(
                copyActPriceSkzsPlanValueRequest({
                    actKC2Id: actId,
                    workOrderPriceId,
                }),
            );
        },
        [copyActPriceSkzsPlanValueRequest, dispatch],
    );

    const handleCopyAllPlanValues = useCallback(
        (actId: number) => {
            dispatch(
                copyActAllSkzsValuesRequest({
                    actKC2Id: actId,
                }),
            );
        },
        [copyActAllSkzsValuesRequest, dispatch],
    );

    return {
        handleCopyAllPlanValues,
        handleCopyPricePlanValue,
    };
};
